import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppBreadcrumb = _resolveComponent("AppBreadcrumb")!
  const _component_CreateEditLicenseForm = _resolveComponent("CreateEditLicenseForm")!
  const _component_AppContainer = _resolveComponent("AppContainer")!

  return (_openBlock(), _createBlock(_component_AppContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_AppBreadcrumb, { items: _ctx.breadcrumbItems }, null, 8, ["items"]),
      _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "mb-5" }, "Licenses Create", -1)),
      _createVNode(_component_CreateEditLicenseForm, { onSubmit: _ctx.submit }, null, 8, ["onSubmit"])
    ]),
    _: 1,
    __: [0]
  }))
}